import { Group, PinInput, PinInputProps, Text } from '@mantine/core'

export const Pinput = ({ children, ...props }: PinInputProps) => (
  <Group justify="center">
    <Text fw="bold">Verification Code</Text>
    <PinInput
      type="number"
      oneTimeCode
      aria-label="One time code"
      length={6}
      {...props}
    />
    {children}
  </Group>
)
